// extracted by mini-css-extract-plugin
export default {"maincontainer":"home_maincontainer__V7QCe"};